import { useEffect, useState, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Spin } from 'antd';
import { notification } from 'antd'
import type { NotificationPlacement } from 'antd/es/notification'
import { Typography, Button, OTP, EnhancedStepProgress, CheckoutCard } from 'mobily-ui-library/lib';
import { GlobalContext } from '../../context/GlobalContext';
import moment from 'moment';
import checkoutCardImg from '../../assets/checkoutCardImg.jpg';
import './OrderDetails.scss'
import User from '../../assets/User.svg';
import Phone from '../../assets/Phone.svg';
import Mail from '../../assets/Mail.svg';
import LocationPin from '../../assets/LocationPin.svg';
import Calendar from '../../assets/Calendar.svg';

const OrderDetails = () => {
  const { t } = useTranslation()
  const [state, dispatch]: any = useContext(GlobalContext);
  const { rtl, showDetails, inquiryRes, orderNumber, changesSaved, changedAddress, changedNotes, selectedOrderDetails } = state;
  const win: any = window
  var serverURL = win['base_portal_url']
  var errorPage = win['errorPageURL']
  const [loading, setLoading] = useState(false)
  const dir = rtl ? 'right' : 'left'
  let componentToDisplay = <></>
  let inquiryResData: any = selectedOrderDetails ? selectedOrderDetails : inquiryRes.orders;
  const steps = inquiryResData[0].orderTimeline;
  const ordNum = inquiryResData[0].orderInfo.OrderNumber;
  const updatedDate = inquiryResData[0].orderInfo.LastUpdatedDate;
  const currentDate = new Date();
  const valDate = moment(currentDate).format('MM/DD/YYYY HH:mm');
  let todayDate = moment(valDate, "MM/DD/YYYY HH:mm");
  let lastUpdated = "";

  const compareDates = (date1: any, date2: any) => {
    const parsedDate1 = new Date(date1);
    const parsedDate2 = new Date(date2);
    const displayDate = moment(date2, "MM/DD/YYYY HH:mm");
    const isSameDate = parsedDate1.getDate() === parsedDate2.getDate() &&
      parsedDate1.getMonth() === parsedDate2.getMonth() &&
      parsedDate1.getFullYear() === parsedDate2.getFullYear()
      // if date1 and date2 are same dates isSameDate will true and only time will display
    const lastUpdate = isSameDate ? t('last_updated_today') + ' ' + displayDate.format('HH:mm') :
      t('last_updated_on') + ' ' + displayDate.format('DD/MM/YYYY HH:mm')
    lastUpdated = lastUpdate;
  }

  compareDates(todayDate, updatedDate)

  const selectedNumber = inquiryResData[0]?.orderInfo?.MSISDN === "NA" ? "" : inquiryResData[0].orderInfo.MSISDN;
  const selectedPackage = rtl ? inquiryResData[0].orderInfo.Plan_Arabic : inquiryResData[0].orderInfo.Plan_English;
  const OrderType = inquiryResData[0].orderInfo.OrderType;
  const duration = inquiryResData[0]?.orderInfo?.Duration === "NA" ? "" : inquiryResData[0].orderInfo.Duration;
  let orderTypeName = "";
  if (OrderType === "Physical SIM") {

    orderTypeName = t('with_physical_sim');
  } else if (OrderType === "MNP eSIM") {

    orderTypeName = t('with_eSIM');
  } else if (OrderType === 'FTTH') {

    orderTypeName = duration;
  } else if (OrderType === "MNP Physical SIM") {

    orderTypeName = t("with_physical_SIM");

  } else {

    orderTypeName = OrderType;

  }
  const estimateDelivery = inquiryResData[0].orderInfo.EstimateDelivery;
  const deliveryAddress = changedAddress ? changedAddress : inquiryResData[0].orderInfo.DeliveryAddress;
  const deliveryNotes = changedNotes ? changedNotes : inquiryResData[0].orderInfo.DeliveryNote;

  const dueAmount = inquiryResData[0].orderSummary.DueAmount ? inquiryResData[0].orderSummary.DueAmount : null;
  const packageAmount = inquiryResData[0].orderSummary.PackageAmount ? inquiryResData[0].orderSummary.PackageAmount : null;
  const vatAmount = inquiryResData[0].orderSummary.VatAmount;
  const securityDepositAmount = inquiryResData[0].orderSummary.SecurityDepositAmount ? inquiryResData[0].orderSummary.SecurityDepositAmount : null;
  const totalAmount = inquiryResData[0].orderSummary.TotalAmount;
  const deliveryAmount = inquiryResData[0].orderSummary.DeliveryAmount ? inquiryResData[0].orderSummary.DeliveryAmount : null;
  const paymenType = t(inquiryResData[0].orderInfo.PaymentType.toLowerCase().replaceAll(' ', '_'));
  const orderStatus = inquiryResData[0].orderInfo.OrderStatus.toLowerCase().replaceAll(' ', '_');
  let cardImg: any = inquiryResData[0].orderInfo.PlanImage === "" || inquiryResData[0].orderInfo.PlanImage == "NA" ? checkoutCardImg : inquiryResData[0].orderInfo.PlanImage;
  const reciverDetails = {
    name: inquiryResData[0]?.customerInfo?.ReceiverName || inquiryResData[0].customerInfo.ReceiverName != "NA" ? inquiryResData[0].customerInfo.ReceiverName : "",
    pNumber: inquiryResData[0]?.customerInfo?.ReceiverContactNumber || inquiryResData[0].customerInfo.ReceiverContactNumber != "NA" ? inquiryResData[0].customerInfo.ReceiverContactNumber : "",
    email: inquiryResData[0]?.customerInfo?.ReceiverEmail || inquiryResData[0].customerInfo.ReceiverEmail != "NA" ? inquiryResData[0].customerInfo.ReceiverEmail : ""
  }
  let stepsData = steps.map((value: any) => {
    let stepVal = value.stepDisplayValue.replaceAll(" ", "_");
    value.stepDisplayValue = t(stepVal.toLowerCase()).replaceAll("_", " ");
    if (value.action?.actionAllowed === "Y") {
      let actName = value.action?.actionName.replaceAll(" ", "_");
      value.action.actionName = t(actName).replaceAll("_", " ");
      value.action.actionFunction = () => {
        if (showDetails === 'true') {
          if (value.action.actionName === t("CHANGE_DELIVERY")) {
            dispatch({ type: "GO_TO_SCREEN", payload: { page: 'DeliveryDetails' } });
          } else if (value.action.actionName === t("CANCEL_TRANSFER")) {
            dispatch({ type: "GO_TO_SCREEN", payload: { page: 'CancelTransferRequest' } });
          }
        } else {
          dispatch({ type: "ORDER_DETAILS_SUCCESS", payload: { actionName: value.action.actionName } });
          dispatch({ type: "GO_TO_SCREEN", payload: { page: 'OtpScreen' } });
        }
      }
    }
    return (value)
  })


  const showEditDelivery = stepsData.filter((value: any) => {
    return (value.action?.actionName === t("CHANGE_DELIVERY"))
  })

  useEffect(() => {
    window.scroll({ top: 0, left: 0 })
    if (changesSaved === "true") {
      openNotification('top');
    }
  }, []);


  const editDelivery = () => {
    if (showDetails === 'true') {
      dispatch({ type: "GO_TO_SCREEN", payload: { page: 'DeliveryDetails' } });
    } else {
      dispatch({ type: "GO_TO_SCREEN", payload: { page: 'OtpScreen' } });
    }
  };

  const openNotification = (placement: NotificationPlacement) => {
    notification.open({
      message: t("🎉Changes saved!"),
      placement,
      //duration: 0,
      style: {
        height: '52px',
        width: '366px',
        textAlign: 'center',
        borderTopLeftRadius: '8px',
        borderTopRightRadius: '8px',
        borderBottomLeftRadius: '8px',
        borderBottomRightRadius: '8px',
        background: 'rgba(35, 42, 45, 0.9)',
      },
    })
  }

  if (loading) {
    componentToDisplay = <Spin className="spinLoader" size="large" />
  } else {
    componentToDisplay = (
      <>
        <div className="orderDetails_container">
          <div className="orderDetails_heading_container">
            <Typography rtl={rtl} className="orderDetails_title">
              {t('your_order') + ordNum}
            </Typography>
            <Typography rtl={rtl} className="orderDetails_subTitle">
              {lastUpdated}
            </Typography>
          </div>
          <div className="testSize">
            <div className="parcelOverview">
              <div className="frameProcessed">
                <Typography rtl={rtl} className="numberOfOrder">
                  {t('order_status')}
                </Typography>
                <Typography rtl={rtl} className="processed_title">
                  {t(orderStatus)}
                </Typography>
              </div>
              <div className="media">
                <div className="estimateDelivery sansFont">
                  <Typography rtl={rtl} className="estimatre_title ">
                    {t('estimate_delivery')}
                  </Typography>
                  <Typography rtl={rtl} className="estimatre_date">
                    {estimateDelivery}
                  </Typography>
                </div>
                <div className="payOnDelivery">
                  <Typography rtl={rtl} className="payOnDelivery_title sansFont">
                    {paymenType}
                  </Typography>
                  <Typography rtl={rtl} className="payOnDelivery_price">
                    {totalAmount + t('sar')}
                  </Typography>
                </div>
              </div>
            </div>
            <div className="rectangle">
              <CheckoutCard rtl={rtl} banner={cardImg} productName={selectedPackage} phoneNumber={selectedNumber} description={orderTypeName} amount={packageAmount} />
              <hr className="theLine" />
              <EnhancedStepProgress rtl={rtl} steps={stepsData} />
              <hr style={{ display: showDetails === 'true' ? '' : 'none' }} className="theLine" />
              <div style={{ display: showDetails === 'true' ? '' : 'none' }} className={`Ecommerce_Checkout--communication `}>
                <div className='communication-receiver'>
                  <div className='communication__card-header'>
                    <Typography rtl={rtl} className='delivery-heading'>{t('receiver')}</Typography>
                    {/* <Typography rtl={rtl} className='communication-edit' onClick={() => { }}>{t('edit')}</Typography> */}
                  </div>
                  <div className='communication-receiverContainer'>
                    <div className='communication-name' >
                      <img src={User} alt='person' />
                      <Typography rtl={rtl} className='sansFont'>{reciverDetails.name}</Typography>
                    </div>
                    <div className='communication-phone'>
                      <img src={Phone} alt='phone' />
                      <Typography rtl={rtl} className='sansFont'>{reciverDetails.pNumber}</Typography>
                    </div>
                    <div className='communication-email'>
                      <img src={Mail} alt='email' />
                      <Typography rtl={rtl} className='sansFont'>{reciverDetails.email}</Typography>
                    </div>
                  </div>
                </div>

                <div className='communication-deliveryDetails' >
                  <div className='communication__card-header'>
                    <Typography rtl={rtl} className='delivery-heading' >{t('delivery_details')}</Typography>
                    {showEditDelivery[0]?.action?.actionName === t("CHANGE_DELIVERY") ?
                      <Typography rtl={rtl} className='communication-edit' onClick={editDelivery}>{t('edit')}</Typography>
                      : <></>}
                  </div>
                  <div className='communication-receiverContainer'>
                    <div className='communication-calendar' >
                      <img src={Calendar} alt='calendar' />
                      <Typography rtl={rtl} className='sansFont'>{estimateDelivery}</Typography>
                    </div>
                    <div className='communication-name'>
                      <img className='locationImg' src={LocationPin} alt='location' />
                      <Typography rtl={rtl} className='delivery_address sansFont'>{deliveryAddress}</Typography>
                    </div>
                    <Typography rtl={rtl} className='location-note sansFont'>{deliveryNotes}</Typography>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className='ec_order_container' >
            <div className={'Ecommerce_Checkout--orderSummary'}>
              <Typography rtl={rtl} className='orderSummary-heading'>{t('order_summary')}</Typography>

              <div className='orderSummary--paymentDetails'>
                {packageAmount !== null ?
                  <div className='orderSummary--flex'>
                    <Typography rtl={rtl} className='orderSummary-title sansFont'>{t('one_time_fee')}</Typography>
                    <Typography rtl={rtl} className='orderSummary-amount sansFont'>{packageAmount} {t('sar')}</Typography>
                  </div> : null
                }

                {packageAmount !== null ?
                  <div className='orderSummary--flex' >
                    <Typography rtl={rtl} className='orderSummary-title sansFont'>{t('security_deposit')}</Typography>
                    <Typography rtl={rtl} className='orderSummary-amount sansFont'>{securityDepositAmount} {t('sar')}</Typography>
                  </div> : null
                }


                {packageAmount !== null ?
                  <div className='orderSummary--flex' >
                    <Typography rtl={rtl} className='orderSummary-title sansFont'>{t('over_due_bills')}</Typography>
                    <Typography rtl={rtl} className='orderSummary-amount sansFont'>{dueAmount} {t('sar')}</Typography>
                  </div> : null
                }


                {deliveryAmount !== null ?
                  <div className='orderSummary--flex' >
                    <Typography rtl={rtl} className='orderSummary-title sansFont'>{t('delivery')}</Typography>
                    <Typography rtl={rtl} className='orderSummary-amount sansFont'>{deliveryAmount} {t('sar')}</Typography>
                  </div> : null
                }


                {/* <div className='orderSummary--flex' >
                  <Typography rtl={rtl} className='orderSummary-title sansFont'>{t('vat_included')}</Typography>
                  <Typography rtl={rtl} className='orderSummary-amount sansFont'>20{t('sar')}</Typography>
                </div> */}


                <div className='orderSummary--flex'>
                  <Typography rtl={rtl} className='orderSummary-title sansFont'>15% {t('vat')}</Typography>
                  <Typography rtl={rtl} className='orderSummary-amount sansFont'> {vatAmount} {t('sar')}</Typography>
                </div>
              </div>

              <div className='partition'></div>

              <div className='TotalPay-Sections'>
                <div className='orderSummary--flex'>
                  <Typography rtl={rtl} className='totalPay-title'>{paymenType}</Typography>
                  <Typography rtl={rtl} className='totalPay-amount'>{totalAmount} <span>{t('sar')}</span> </Typography>
                </div>
                <Typography rtl={rtl} className='sansFont taxes'>({t('incl')} 15% {t('vat')})</Typography>
              </div>
            </div>
          </div>


        </div>
      </>
    )
  }
  return componentToDisplay
}

export default OrderDetails
